import { oneLine } from 'common-tags/es';

const data = {
    type: 'contentpage',
    path: '/measures/health',
    meta: {
        title: 'Good health | Child Poverty',
    },
    layout: 'image-right',
    title: 'Good health',
    intro: oneLine`Tamariki living in areas with the highest deprivation scores are <b>twice as likely</b> to end up in 
        hospital than tamariki in areas with the lowest deprivation scores.`,
    image: {
        filename: 'Health.png',
        alt: '',
    },
    content: [
        oneLine`<p>The most common diagnoses for tamariki hospitalised with a medical condition in the five years 
            from 2015–2019 were diseases of the respiratory system, accounting for 37% of hospital admissions in 
            0-14 year olds.</p>`,
        oneLine`<p>It is possible that the COVID-19 lockdown limited transmission of respiratory infections between 
            households. In the winter of 2020 paediatric wards in Aotearoa New Zealand noted a marked decrease in 
            hospitalisations of babies and toddlers with respiratory infections.</p>`,
    ],
};

export default data;
